import React from 'react';

import { createUseStyles } from 'react-jss';

import { RadioButton } from 'primereact/radiobutton';

import MzRoundedBox from './MzRoundedBox';

function MzRadioButton({ inputId, label, name, value, stateValue, setStateValue, onChange }) {
  const st = styles();

  let [borderStyle, setBorderStyle] = React.useState({});


  React.useEffect(()=>{
    if (stateValue === value)
    setBorderStyle({ borderColor: "var(--primary-color)" , borderWidth:"2px" })
  else
    setBorderStyle({})
  },[stateValue,value])


  const onInternalChange = e => {
    setStateValue(e.value);
    //debugger;
    

    if (onChange)
      onChange(e);
  }
  //
  return (
    <div  className={"w-full "+ st.container}>

      <MzRoundedBox className={"w-full"} style={ borderStyle}>
        <RadioButton   inputId={inputId} name={name} value={value} onChange={(e) => onInternalChange(e)} checked={stateValue === value} />
        <label htmlFor={inputId} className="ml-2">{label}</label>
      </MzRoundedBox>
    </div>
  );
}

const styles = createUseStyles({
  container: {
    backgroundColor:"white",
    overflow:"hidden",
    borderRadius:"15px"
  }
});

export default MzRadioButton;